var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Api from '../model/api';
import Emitter from '../utils/emitter';
import { decorator } from '../utils/instance';
import ServerTime from '../module/server-time';
var filesFieldName = 'file';
function fileLocalLoad(file) {
    return new Promise(function (resolve) {
        var fr = new FileReader();
        fr.onload = function () {
            var img = new Image();
            img.onload = function () {
                resolve([img.width, img.height]);
            };
            img.src = fr.result;
        };
        fr.readAsDataURL(file);
    });
}
var MsgImage = (function (_super) {
    __extends(MsgImage, _super);
    function MsgImage(config) {
        var _this = _super.call(this) || this;
        _this._ossCache = {};
        _this.config = config;
        _this._api = Api.getInstance(config);
        _this._stime = new ServerTime(config);
        return _this;
    }
    MsgImage.prototype.getUploadToken = function () {
        var config = this.config;
        var param = {
            accessKey: config.accessKey,
            accessToken: config.accessToken,
            userAccountType: config.accountType,
        };
        return this._api.request(config._url.upImgToken, param).catch(function (err) {
            return {};
        });
    };
    MsgImage.prototype.uploadImg = function (files, cb) {
        return __awaiter(this, void 0, void 0, function () {
            var config, file, _a, fileAttr_1, data, token, formData_1, xhr_1, onProgress, ex_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        config = this.config;
                        file = files[0];
                        if (!file) {
                            return [2, Promise.reject('NO_UPLOAD_CONTENT::无可上传内容')];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, Promise.all([
                                fileLocalLoad(file),
                                this.getUploadToken(),
                            ])];
                    case 2:
                        _a = __read.apply(void 0, [_b.sent(), 2]), fileAttr_1 = _a[0], data = _a[1];
                        token = data.result;
                        formData_1 = new FormData();
                        formData_1.append(filesFieldName, file);
                        formData_1.append('userId', "" + config.accountType + config.userId);
                        formData_1.append('dirId', 0);
                        formData_1.append('token', token);
                        if (config.env === 'daily') {
                            formData_1.append('bizCode', 'lazada-im');
                        }
                        else {
                            formData_1.append('bizCode', "lazada-im-" + config.region);
                        }
                        xhr_1 = new XMLHttpRequest();
                        if (cb) {
                            onProgress = function (e) {
                                var done = e.position || e.loaded;
                                var total = e.totalSize || e.total;
                                console.log('xhr progress: ' + Math.round(done / total * 100) + '%');
                                cb(done, total);
                            };
                            xhr_1.addEventListener('progress', onProgress);
                            (xhr_1.upload || xhr_1).addEventListener('progress', onProgress);
                            xhr_1.upload.onprogress = onProgress;
                            xhr_1.onprogress = onProgress;
                        }
                        xhr_1.open('POST', config._url.uploadImg, true);
                        return [2, new Promise(function (resolve, reject) {
                                xhr_1.onload = function () {
                                    if (xhr_1.status >= 200 && xhr_1.status < 400) {
                                        var data_1 = xhr_1.responseBody || JSON.parse(xhr_1.responseText);
                                        if (data_1 && data_1.jsonData && data_1.success) {
                                            var uri = data_1.jsonData.url.replace(/^(?:https?:)\/\/[^/]+\//, '');
                                            resolve({ imgUrl: '', osskey: uri, width: fileAttr_1[0], height: fileAttr_1[1] });
                                        }
                                        else {
                                            reject(data_1.errorCode + "::" + data_1.errorMessage);
                                        }
                                    }
                                    else {
                                        reject(new Error(xhr_1.responseBody));
                                    }
                                };
                                xhr_1.onerror = function (error) {
                                    reject(error);
                                };
                                xhr_1.send(formData_1);
                            })];
                    case 3:
                        ex_1 = _b.sent();
                        throw ex_1;
                    case 4: return [2];
                }
            });
        });
    };
    MsgImage.prototype.getDownloadToken = function (osskey) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, config, _ossCache, ossObj, param, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, config = _a.config, _ossCache = _a._ossCache;
                        ossObj = _ossCache[osskey];
                        if (_ossCache[osskey] && this._stime.getTime() < ossObj.time) {
                            return [2, Promise.resolve(ossObj.url)];
                        }
                        param = {
                            accessKey: config.accessKey,
                            accessToken: config.accessToken,
                            objectKey: osskey,
                        };
                        return [4, this._api.request(config._url.getImgDownloadToken, param).catch(function (err) {
                                return {};
                            })];
                    case 1:
                        data = _b.sent();
                        this._ossCache[osskey] = {
                            url: data.downloadUrl,
                            time: this._stime.getTime() + data.expiration * 1000,
                        };
                        return [2, data.downloadUrl];
                }
            });
        });
    };
    MsgImage = __decorate([
        decorator
    ], MsgImage);
    return MsgImage;
}(Emitter));
export default MsgImage;
